import { getCompressedAssetUrl } from 'lib/config/assetUrls';

export function howItWorksAsset(path: string): string {
  const clean = path.startsWith('/') ? path : `/${path}`;
  // Speedsize caches origin files for a year. v=2 skips the pre-upload copies.
  return getCompressedAssetUrl(`${clean}?v=2`);
}
